<template>
  <div class="login">
    <sm-inner-loading v-model="onLoading" class="filters_loading"/>
    <div class="login__box">
      <div class="login__box__logo">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="43" viewBox="0 0 175 45"><g id="logo-alegra" fill="none" fill-rule="evenodd"><path class="logo-symbol" fill="#00b19d" fill-rule="nonzero" d="M52.4,34.3 C52.4,34.3 38.4,41 22.9,37.4 C13.5,35.2 0,27.5 0,27.5 L14,8.9 C14,8.9 20.7,19.4 28.9,25.8 C43.1,36.9 52.4,34.3 52.4,34.3 M47.7,31.8 C47.7,31.8 41.2,29.1 38,16.4 C36.1,9 37,0 37,0 L20.6,4.4 C20.6,4.4 24.9,14.9 29.3,20.4 C36.6,29.4 47.7,31.8 47.7,31.8 M46.1,27.8 C46.1,27.8 44,23.5 48,15.6 C50.3,11 54.8,6.8 54.8,6.8 L44.5,1.7 C44.5,1.7 42,8.9 41.8,13.7 C41.6,21.6 46.1,27.8 46.1,27.8 M47.4,23.8 C47.4,23.8 48.3,21.2 53.2,19.6 C56,18.7 59.6,18.8 59.6,18.8 L57.4,12.5 C57.4,12.5 53.4,14.5 51.4,16.3 C48.1,19.4 47.4,23.8 47.4,23.8"></path><path class="logo-text" fill="#595959" fill-rule="nonzero" d="M90,34.8 L92.5,34.8 L92.5,5.4 L90,5.4 L90,34.8 Z M147.2,18.8 L147.2,15.5 L144.7,15.5 L144.7,34.8 L147.3,34.8 L147.3,24.1 C147.3,22.1 147.7,20.8 149.3,19.5 C150.4,18.6 151.4,18.3 152.8,18.2 L152.8,15.6 C150.3,15.8 148.5,16.4 147.2,18.8 L147.2,18.8 Z M115.5,21.6 C114.1,17.7 110.3,15.1 106.1,15.1 C100.5,15.1 96.1,19.7 96.1,25.2 C96.1,30.7 100.6,35.3 106.1,35.3 C110,35.3 113.7,32.9 115.3,29.3 L112.5,29.3 C111.2,31.5 108.6,33.1 106.1,33.1 C102.3,33.1 98.9,29.9 98.7,26.1 L116.2,26.1 C116.1,24.5 116.1,23.1 115.5,21.6 L115.5,21.6 Z M98.7,23.9 C99.3,20.2 102.3,17.3 106.1,17.3 C110,17.3 112.7,20.3 113.5,23.9 L98.7,23.9 Z M83.3,18.6 C81.8,16.7 78.8,15.1 75.7,15.1 C70,15.1 65.3,19.4 65.3,25.2 C65.3,30.9 70,35.3 75.7,35.3 C78.9,35.3 81.4,34 83.3,31.5 L83.3,34.9 L85.8,34.9 L85.8,25.6 L85.8,25.6 C85.8,25.5 85.8,25.4 85.8,25.3 C85.8,22.6 84.9,20.3 83.3,18.6 L83.3,18.6 Z M75.7,33.1 C71.4,33.1 67.8,29.5 67.8,25.2 C67.8,20.9 71.4,17.3 75.7,17.3 C80,17.3 83.3,21 83.3,25.2 C83.3,29.4 80,33.1 75.7,33.1 L75.7,33.1 Z M174.4,25.2 C174.4,22.6 173.5,20.3 171.9,18.6 C170.4,16.7 167.4,15.1 164.3,15.1 C158.6,15.1 153.9,19.4 153.9,25.2 C153.9,30.9 158.6,35.3 164.3,35.3 C167.5,35.3 170,34 171.9,31.5 L171.9,34.9 L174.4,34.9 L174.4,25.6 L174.4,25.6 C174.4,25.4 174.4,25.3 174.4,25.2 L174.4,25.2 Z M164.3,33.1 C160,33.1 156.4,29.5 156.4,25.2 C156.4,20.9 160,17.3 164.3,17.3 C168.6,17.3 171.9,21 171.9,25.2 C171.9,29.4 168.5,33.1 164.3,33.1 L164.3,33.1 Z M137.6,18.5 C136.2,16.5 133.1,15.1 129.9,15.1 C124.3,15.1 120,19.9 120,25.3 C120,30.8 124.5,35.3 130,35.3 C133,35.3 136.3,33.9 137.5,31 L137.5,35.3 C137.5,39.4 134.5,42.3 130.3,42.3 C128.7,42.3 127,41.8 125.7,40.8 C124.6,40 123.8,38.6 123.1,37.4 L120.6,37.4 C121,38.5 121.3,39.3 121.9,40.3 C123.7,42.9 126.9,44.5 130.1,44.5 C133.1,44.5 136.2,43.2 138.2,40.9 C139.8,38.9 140,37.3 140,34.7 L140,25.3 C140.1,22.8 139.2,20.4 137.6,18.5 L137.6,18.5 Z M130.1,33.1 C125.7,33.1 122.5,29.4 122.5,25.1 C122.5,20.9 125.6,17.3 129.9,17.3 C134.2,17.3 137.6,20.9 137.6,25.1 C137.6,29.3 134.4,33.1 130.1,33.1 L130.1,33.1 Z"></path><text class="logo-country" fill="#00b19d" font-family="Roboto" font-size="9" font-weight="normal" opacity="1"><tspan x="100%" y="8" text-anchor="end">LENDING</tspan></text></g></svg>
      </div>
      <div class="login__box__header">Ingresa a tu cuenta</div>
      <div class="login__box__description">Sigue ganando tiempo y tranquilidad</div>
      <div class="login__box__error-message" v-show="onError">Usuario o clave inválida. ¡Inténtalo de nuevo!</div>
      <sm-input @keyup.enter="login" v-model="email" nativeType="text" placeholder="Correo/Usuario" size="medium" inputClass="login__box__username"/>
      <sm-input @keyup.enter="login" v-model="password" nativeType="password" placeholder="Contraseña" size="medium" inputClass="login__box__password"/>
      <sm-button
        label="INGRESAR"
        size="medium"
        primary
        class="login__box__button"
        @click="login"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    onLoading () {
      return Object.is(this.$store.getters.status, 'loading')
    },
    onError () {
      return Object.is(this.$store.getters.status, 'error')
    }
  },
  methods: {
    login () {
      const { email, password } = this
      this.$store.dispatch('login', { email, password })
    }
  }
}
</script>

<style>
.login {
  background-color: #ffffff;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.login__box {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 145px 80px;
  width: calc(50% - 200px);
}

.login__box__error-message {
  color: #e85e42;
  font-size: 85%;

  background: #fff2f3;
  margin: 10px 0;
  padding: 5px;
}

.login__box__header {
  color: #999999;
  font-size: 16px;
  font-weight: 400;

  margin-top: -5px;
}

.login__box__description {
  color: #00b19d;
  font-size: 14px;
  font-weight: 400;

  margin-bottom: 50px;
}

.login__box__username {
  width: 100%;
}

.login__box__password {
  width: 100%;
}

.login__box__button {
  margin-top: 20px;
  width: 100%;
}

.login__box__button:hover {
  background: rgba(0,83,94,0.93);
}
</style>
